import { connect } from 'react-redux';
import { getLocale } from 'app/api/redux-watson/watson-config-selectors';

const mapStateToProps = state => ({
  locale: getLocale(state),
});

export default function withLocale(LocalizedComponent) {
  return connect(mapStateToProps)(LocalizedComponent);
}
